<template>
  <PageLayout
    class="branches-page"
  >
    <Branches />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import { default as Branches } from '../../views/organizations/Index.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';

export default {
  created() {
    this.changeActivePage(pages.ORDERS);
  },
  components: { PageLayout, Branches },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
::v-deep .base-modal {
    .content {
        flex-grow: 0 !important;
        padding: 0 !important;
    }
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
</style>
